import PropTypes from 'prop-types';
import { Box, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    title: {
        marginTop: 10,
        maxHeight: 37,
        overflow: 'hidden',
        color: 'black',
        textOverflow: 'ellipses',
    },
    date: {
        textAlign: 'right',
        margin: 10,
        fontSize: 12,
    },
    newsItem: {
        position: 'relative',
        width: '100%',
        backgroundColor: 'white',
        borderRadius: 6,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundSize: 'cover',
        alignItems: 'flex-end',
        marginTop: 10,
        cursor: 'pointer',
        overflow: 'hidden',
    },
    newsItemCard: {
        width: '100%',
        backgroundColor: 'white',
        borderRadius: 6,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundImage: 'url(news/news1.jpeg)',
        backgroundSize: 'cover',
        alignItems: 'end',
        marginTop: 10,
        lineHeight: 1.2,
    },
    radTitle: {
        backgroundColor: 'red',
        padding: '5px 10px',
        width: 'fit-content',
        borderRadius: 22,
        color: 'white',
        fontSize: 10,
        margin: '0px 0px 7px -2px',
    },
    newsTitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: 1.4,
        height: 35,
    },
    newsItemHover: {
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        height: '100%',
        opacity: 0,
        backgroundColor: 'black',
        '&:hover': {
            opacity: 0.3,
        },
    },
}));

const NewsCard = (props) => {
    const classes = useStyles();

    return (
        <Box
            className={classes.newsItem}
            style={{
                height: props.size === 'lg' ? 418 : 202,
                backgroundImage:
                    props.data.itemType === 'local'
                        ? `url(${props.data.image})`
                        : `url(${props.data.coverImg ? props.data.coverImg.url : null})`,
            }}
            onClick={props.onClick}
        >
            <Box className={classes.newsItemHover}></Box>
            {/*мэдээний зураг*/}
            <Box
                style={{
                    background: 'linear-gradient(0deg,rgba(0,0,0,.9),rgba(0,0,0,0))',
                    width: '100%',
                    borderRadius: 6,
                }}
            >
                {' '}
                {/*хар зураг*/}
                <Box style={{ padding: 20 }}>
                    {/* <Box className={classes.radTitle}>
                        <Typography style={{ fontWeight: 600 }}>{props.data.typeName}</Typography>
                    </Box> */}
                    <Typography
                        className={classes.newsTitle}
                        style={{ color: 'white' }}
                        variant="subtitle1"
                    >
                        {props.data && props.data.title}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

NewsCard.defaultProps = {
    title: 'name',
    createAt: '2020/01/01',
};

NewsCard.propTypes = {
    title: PropTypes.string,
    createdAt: PropTypes.string,
};

export default NewsCard;
